import React from 'react';

function Numbers_0_10Chart() {
    return (
        <table className="table is-bordered is-striped is-narrow is-hoverable">
            <thead>
                <tr>
                    <th>Number</th>
                    <th>Spelling</th>
                    <th>Notes</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <th>0</th>
                    <td>Ноль</td>
                    <td>-</td>
                </tr>
                <tr>
                    <th>1</th>
                    <td>Один</td>
                    <td>-</td>
                </tr>
                <tr>
                    <th>2</th>
                    <td>Два</td>
                    <td>-</td>
                </tr>
                <tr>
                    <th>3</th>
                    <td>Три</td>
                    <td>-</td>
                </tr>
                <tr>
                    <th>4</th>
                    <td>Четыре</td>
                    <td>-</td>
                </tr>
                <tr>
                    <th>5</th>
                    <td>Пять</td>
                    <td>-</td>
                </tr>
                <tr>
                    <th>6</th>
                    <td>Шесть</td>
                    <td>-</td>
                </tr>
                <tr>
                    <th>7</th>
                    <td>Семь</td>
                    <td>-</td>
                </tr>
                <tr>
                    <th>8</th>
                    <td>Восемь</td>
                    <td>-</td>
                </tr>
                <tr>
                    <th>9</th>
                    <td>Девять</td>
                    <td>-</td>
                </tr>
                <tr>
                    <th>10</th>
                    <td>Десять</td>
                    <td>-</td>
                </tr>
            </tbody>

        </table>
    );
}

export default Numbers_0_10Chart;
